<template>
  <div class="app">
    <!-- Show access denied if user tried to login but is not admin -->
    <div v-if="showAccessDenied" class="access-denied">
      <h1>Access Denied</h1>
      <p>Admin privileges required to access this application.</p>
      <button class="back-btn" @click="showAccessDenied = false">Back to Login</button>
    </div>

    <!-- Show dashboard if authenticated and admin -->
    <Dashboard v-else-if="isAuthenticated && isAdmin" @logout="handleLogout" />

    <!-- Show login form otherwise -->
    <LoginForm v-else @login-success="handleLoginSuccess" />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { isAuthenticated, isAdmin } from './client.js';
import LoginForm from './components/LoginForm.vue';
import Dashboard from './components/Dashboard.vue';

const showAccessDenied = ref(false);

const handleLoginSuccess = () => {
  if (!isAdmin.value) {
    showAccessDenied.value = true;
  }
};

const handleLogout = () => {
  showAccessDenied.value = false;
};

onMounted(() => {
  // Check if user was already logged in but lost admin privileges
  if (isAuthenticated.value && !isAdmin.value) {
    showAccessDenied.value = true;
  }
});
</script>

<style scoped>
.app {
  min-height: 100vh;
}

.access-denied {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  text-align: center;
}

.access-denied h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #dc2626;
}

.access-denied p {
  font-size: 1.125rem;
  color: #6b7280;
  margin-bottom: 2rem;
}

.back-btn {
  padding: 0.75rem 1.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  cursor: pointer;
}

.back-btn:hover {
  background: #2563eb;
}
</style>
